import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import styles from "./claimable-authenticator-v2.module.scss";

export const PASSWORD_REQUIREMENTS = [
  {
    key: "length",
    label: "At least 8 characters",
    test: (pw: string) => pw.length >= 8,
  },
  {
    key: "uppercase",
    label: "One uppercase letter",
    test: (pw: string) => /[A-Z]/.test(pw),
  },
  {
    key: "lowercase",
    label: "One lowercase letter",
    test: (pw: string) => /[a-z]/.test(pw),
  },
  {
    key: "number",
    label: "One number",
    test: (pw: string) => /[0-9]/.test(pw),
  },
  {
    key: "special",
    label: "One special character",
    test: (pw: string) => /[^A-Za-z0-9]/.test(pw),
  },
];

type PasswordRequirementsProps = {
  password: string;
};

const PasswordRequirements = ({ password }: PasswordRequirementsProps) => {
  const allMet = PASSWORD_REQUIREMENTS.every((req) => req.test(password));
  const hasStartedTyping = password.length > 0;
  const shouldShow = hasStartedTyping && !allMet;

  return (
    <ul
      className={`${styles.passwordRequirements} ${shouldShow ? styles.passwordRequirementsVisible : ""}`}
    >
      {PASSWORD_REQUIREMENTS.map((req) => {
        const isMet = req.test(password);
        return (
          <li
            key={req.key}
            className={`${styles.passwordRequirement} ${isMet ? styles.passwordRequirementMet : ""}`}
          >
            <span className={styles.passwordRequirementIcon}>
              <FontAwesomeIcon icon={faCheck} />
            </span>
            <span>{req.label}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default PasswordRequirements;
